import React from 'react';
import { EditButtonStyle } from './EditButton.styles';
import { SquarePen } from 'lucide-react';
import { useIntl } from 'react-intl';

interface EditButtonProps {
  onClick: () => void;
}

export const EditButton: React.FC<EditButtonProps> = ({ onClick }) => (
  <EditButtonStyle
    onClick={onClick}
    aria-label={useIntl().formatMessage({ id: "edit" })}
    title={useIntl().formatMessage({ id: "edit" })}
    >
    <SquarePen size={18} strokeWidth={2.5} />
  </EditButtonStyle>
);